import { render, staticRenderFns } from "./BizBusinessinfoModal1.vue?vue&type=template&id=6a52206e&"
import script from "./BizBusinessinfoModal1.vue?vue&type=script&lang=js&"
export * from "./BizBusinessinfoModal1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports